import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  FetchInitialSellContractValuesActionType,
  FETCH_INITIAL_SELL_CONTRACT_VALUES,
  FETCH_INITIAL_SELL_CONTRACT_VALUES_FAILURE,
  FETCH_INITIAL_SELL_CONTRACT_VALUES_SUCCESS
} from 'src/redux/sellContractReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchSellContractInitialValuesFlow(
  action: FetchInitialSellContractValuesActionType
): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = `/dealers_api/sell_contracts/${action.payload.id}/initial_form_values`
    const response = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: GET,
      params: {}
    })
    yield put(FETCH_INITIAL_SELL_CONTRACT_VALUES_SUCCESS(response))
  } catch (error) {
    yield put(FETCH_INITIAL_SELL_CONTRACT_VALUES_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchSellContractInitialValues(): Generator<any, void, any> {
  yield takeLatest(FETCH_INITIAL_SELL_CONTRACT_VALUES, FetchSellContractInitialValuesFlow)
}
